import { useMemo } from 'react';
import useApiDebug from '../../hooks/useApiDebug';

const formatTimestamp = (ts) => {
  if (!ts) return '—';
  try {
    return new Date(ts).toLocaleTimeString();
  } catch (err) {
    return '—';
  }
};

const formatDuration = (ms) => {
  if (typeof ms !== 'number') return '—';
  if (ms < 1000) return `${ms}ms`;
  return `${(ms / 1000).toFixed(2)}s`;
};

export default function ApiDebugSection() {
  const { apiState } = useApiDebug();

  const statusLabel = useMemo(() => {
    switch (apiState.status) {
      case 'pending':
        return 'pending';
      case 'success':
        return 'success';
      case 'error':
      case 'failed':
        return 'error';
      default:
        return apiState.status || 'idle';
    }
  }, [apiState.status]);

  return (
    <div className="debug-section">
      <div className="debug-section-title">API Debug</div>
      <div className="debug-metric">
        <span>Status:</span>
        <span>{statusLabel}</span>
      </div>
      <div className="debug-metric">
        <span>Endpoint:</span>
        <span>{apiState.endpoint || '—'}</span>
      </div>
      <div className="debug-metric">
        <span>HTTP Status:</span>
        <span>{apiState.httpStatus ?? '—'}</span>
      </div>
      <div className="debug-metric">
        <span>Início:</span>
        <span>{formatTimestamp(apiState.startedAt)}</span>
      </div>
      <div className="debug-metric">
        <span>Duração:</span>
        <span>{formatDuration(apiState.durationMs)}</span>
      </div>
      {apiState.error && (
        <div className="debug-error">
          Erro: {apiState.error}
        </div>
      )}
    </div>
  );
}

